import styled, { css } from 'styled-components';

export interface DivProps {
  $isChecked: boolean;
  $disabled?: boolean;
  $invisibleWhenHidden?: boolean;
  $small?: boolean;
  $medium?: boolean;
}

export const Div = styled.div<DivProps>`
  width: 26px;
  min-width: 26px;
  height: 26px;
  cursor: pointer;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.gradient};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  &::after {
    position: absolute;
    content: '';
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.white};
  }

  .is-checked {
    position: absolute;
    z-index: 1;
    width: 50%;
    height: 50%;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.gradient};
  }

  ${({ $disabled }) =>
    $disabled &&
    css`
      pointer-events: none;
      border: none;
      background: ${({ theme }) => theme.colors.cflowerBlue};
    `};

  ${({ $medium }) =>
    $medium &&
    css`
      width: 24px;
      min-width: 24px;
      height: 24px;
    `}

  ${({ $small }) =>
    $small &&
    css`
      width: 20px;
      min-width: 20px;
      height: 20px;
    `}
`;
